<div class="p-2">
  <input class='form-control form-control-sm' type='search' [(ngModel)]="search" placeholder="Search icons">

  @if (icons.length > 0) {
    <div class="d-flex flex-row flex-wrap justify-content-center"
      style="overflow-y: scroll; min-width: 190px; max-height: 200px">
      @for (icon of icons | searchSortByKeys: ['iconName']: search; track icon) {
        <a (click)="selectIcon(icon)"
          [title]="icon.iconName" class="p-1"
          [ngClass]="{'text-primary': icon.class == selected, 'text-dark': icon.class != selected}">
          <i class="text-center" [style.width]="'20px'" [class]="icon.class"></i>
        </a>
      }
    </div>
  }
</div>